// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".medium[data-v-20dcd386]{width:62.291667rem;margin:0 auto;display:flex}.medium .right[data-v-20dcd386]{width:50.520833rem}", ""]);
// Exports
module.exports = exports;
